import React, { useMemo } from "react";
import chroma from "chroma-js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function BarChartWrapper({ data }) {
  let f = chroma
    .scale(["gray", data[0].color.split("#").pop()])
    .colors(data.length);
  let datasets = [];
  data?.forEach((a, idx) => {
    datasets.push({
      label: a.name,
      backgroundColor: f[idx],
      data: [a.value],
    });
  });

  const ChartData = {
    labels: [""],
    datasets,
  };

  const options = {
    responsive: true,
    aspectRatio: 1,
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        fontSize: 5,
      },
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
        ticks: {
          // forces step size to be 50 units
          stepSize: 10,
        },
      },
    },
  };
  return <Bar data={ChartData} options={options} />;
}

export default BarChartWrapper;
